import { useEffect, useCallback } from 'react'
import { useWebSocket } from './WebSocketProvider'
import { SERVICE_STATUS_EVENTS } from './constants'

const useServiceStatusEvents = (options = {}) => {
  const { subscribe } = useWebSocket()

  const {
    onCreated,
    onUpdated,
    serviceId,
    projectId,
  } = options

  const matchesFilter = useCallback((serviceStatus) => {
    if (serviceId && serviceStatus.dockerServiceId !== serviceId) return false
    if (projectId && serviceStatus.dockerProjectId !== projectId) return false
    return true
  }, [serviceId, projectId])

  const createHandler = useCallback((handler) => {
    if (!handler) return null
    return (serviceStatus) => {
      if (matchesFilter(serviceStatus)) {
        handler(serviceStatus)
      }
    }
  }, [matchesFilter])

  useEffect(() => {
    const unsubscribers = []

    if (onCreated) {
      const handler = createHandler(onCreated)
      if (handler) {
        unsubscribers.push(subscribe(SERVICE_STATUS_EVENTS.CREATED, handler))
      }
    }

    if (onUpdated) {
      const handler = createHandler(onUpdated)
      if (handler) {
        unsubscribers.push(subscribe(SERVICE_STATUS_EVENTS.UPDATED, handler))
      }
    }

    return () => {
      unsubscribers.forEach((unsubscribe) => unsubscribe())
    }
  }, [subscribe, createHandler, onCreated, onUpdated])
}

export default useServiceStatusEvents
